import { render, staticRenderFns } from "./PerguntasIpi.vue?vue&type=template&id=68bfb41f&scoped=true&"
import script from "./PerguntasIpi.vue?vue&type=script&lang=js&"
export * from "./PerguntasIpi.vue?vue&type=script&lang=js&"
import style0 from "./PerguntasIpi.vue?vue&type=style&index=0&id=68bfb41f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfb41f",
  null
  
)

export default component.exports